module.exports = {
	STATION_NATURE_SEAPORT: 'SEAPORT',
	STATION_NATURE_PIEZOMETER: 'PIEZOMETER',
	STATION_NATURE_SECTOR: 'SECTOR',
	STATION_NATURE_PLOT: 'PLOT',
	STATION_NATURE_SOURCE: 'SOURCE',
	STATION_NATURE_QUALITOMETER: 'QUALITOMETER',
	STATION_NATURE_QUALITOMETER_SURFACE: 'QUALITOMETER_SURFACE',
	STATION_NATURE_PLUVIOMETER: 'PLUVIOMETER',
	STATION_NATURE_POLLUTED_SOIL: 'POLLUTED_SOIL',
	STATION_NATURE_INDUSTRIAL_SITE: 'INDUSTRIAL_SITE',
	STATION_NATURE_HYDROLOGICAL_STATION: 'HYDROLOGICAL_STATION',
	STATION_NATURE_TREATMENT_STATION: 'TREATMENT_STATION',
	STATION_NATURE_PIEZO_QUALITO: 'PIEZOQUALITO',
	STATION_NATURE_WATER_COURSE: 'WATER_COURSE',
	STATION_NATURE_WATER_PLAN: 'WATER_PLAN',
	STATION_NATURE_WATER_SHED: 'WATER_SHED',
	STATION_NATURE_COASTLINE: 'COASTLINE',
	STATION_NATURE_PUMPED_VOLUME: 'PUMPED_VOLUME',
	STATION_NATURE_LIMIT: 'LIMIT',
	STATION_NATURE_DEPOSIT: 'DEPOSIT',
	STATION_NATURE_OBSTACLE_FLOW: 'OBSTACLE_FLOW'
}



// WEBPACK FOOTER //
// ./src/station/constants/StationNatureConstants.js